export function getNumber(val: number | null | undefined): number {
  if (val === null || val === undefined) return 0;
  return val;
}
